import { render, staticRenderFns } from "./RelationInput.vue?vue&type=template&id=8f42daf4"
import script from "./RelationInput.vue?vue&type=script&lang=js"
export * from "./RelationInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports